// import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
// import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
// import Ad from '../../../../components/ad/ad';
// import FCLink from '../../../../components/fc_link/fc_link';
import Top50Shuffle from '../../../../components/top_50_shuffle/top_50_shuffle';
import Top50 from '../../../../components/top_50/top_50';
import Social from '../../../../components/social/social';
import SectorsList from '../../../../components/sectors_list/sectors_list';
import matchMediaDesktop from '../../../../../utils/client_util';
// import get from 'lodash/get';
import loadDataYear from './mic2020_year_page_state_manager';
import MicMobileMenu from '../../../../components/mic_mobile_menu/mic_mobile_menu';
import get from 'lodash/get';
import extend from 'lodash/extend';
import Ad from '../../../../components/ad/ad';

const cerosEmbed = `
<div style='position: relative;width: auto;padding: 0 0 60.38%;height: 0;top: 0;left: 0;bottom: 0;right: 0;margin: 0;border: 0 none' id="experience-5e4da796276d0" data-aspectRatio="1.65625" data-tablet-aspectRatio="0.75" data-mobile-aspectRatio="0.8723748"><iframe allowfullscreen src='//view.ceros.com/inc/mic-2020-hero?heightOverride=800&mobileHeightOverride=619' style='position: absolute;top: 0;left: 0;bottom: 0;right: 0;margin: 0;padding: 0;border: 0 none;height: 1px;width: 1px;min-height: 100%;min-width: 100%' frameborder='0' class='ceros-experience' scrolling='no'></iframe></div><script type="text/javascript" src="//view.ceros.com/scroll-proxy.min.js" data-ceros-origin-domains="view.ceros.com"></script>
`;

class MicYear2020 extends Component {
  static loadData(store) {
    return loadDataYear(store);
  }

  constructor() {
    super();

    this.scrollToSection = this.scrollToSection.bind(this);
    this.handleBackToTop = this.handleBackToTop.bind(this);

    this.mic2020 = React.createRef();
    this.top50 = React.createRef();
    this.sectors = React.createRef();
    this.parallax = React.createRef();
    this.isDesktop = false;
    this.handleWindowScroll = this.handleWindowScroll.bind(this);

    this.state = {
      backToTop: false
    };
  }

  componentDidMount() {
    this.isDesktop = !!matchMediaDesktop();

    window.addEventListener('scroll', this.handleWindowScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleWindowScroll);
  }

  handleWindowScroll() {
    if (this.parallax.current) {
      const offset = window.pageYOffset;
      this.parallax.current.style.backgroundPositionY = `${offset * 0.25}px`;
    }

    const currentScroll = window.pageYOffset;
    const latestScroll = this.lastScroll;

    if (
      currentScroll > latestScroll &&
      latestScroll > 1 &&
      this.state.backToTop
    ) {
      this.setState({ backToTop: false });
    } else if (
      (currentScroll < latestScroll || latestScroll < 1) &&
      !this.state.backToTop
    ) {
      this.setState({ backToTop: true });
    }
    this.lastScroll = currentScroll;
  }

  scrollToSection(element, offset = 100) {
    if (element.current) {
      window.scroll({
        top: element.current.offsetTop - offset,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  handleBackToTop() {
    this.scrollToSection(this.mic2020, 0);
  }

  render() {
    const { companies, regions, sectors, config, micYearPage } = this.props;
    const { backToTop } = this.state;
    const adData = get(micYearPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    return (
      <section className="mic-2020" ref={this.mic2020}>
        <header className="mic-2020__header">
          <div
            className="mic-2020__header-ceros"
            dangerouslySetInnerHTML={{ __html: cerosEmbed }}
          />
          <div className="mic-2020__header-container">
            <div className="mic-2020__header-social">
              <Social
                empty={false}
                enableSticky={false}
                modifier="mic-2020"
                uri="https://www.fastcompany.com/most-innovative-companies/2020"
                text={{
                  twitter: encodeURIComponent(
                    `These are the 50 Most Innovative Companies of 2020`
                  ),
                  linkedin: encodeURIComponent(
                    `These are the 50 Most Innovative Companies of 2020`
                  ),
                  email: encodeURIComponent(
                    `These are the 50 Most Innovative Companies of 2020 https://fastcompany.com/most-innovative-companies/2020`
                  )
                }}
                subject="These are the 50 Most Innovative Companies of 2020"
              />
            </div>
            <div className="mic-2020__header-content">
              <p>
                It’s 2020, and we don’t have flying cars (yet), but think about
                the cool things that we <em>do</em> have: Augmented reality that
                brings joy into the daily lives of more than 163 million people.
                Drones that deliver vital medicine. An effective treatment for
                postpartum depression. Creative ways to curb society’s addiction
                to new clothing and single-use plastic. Platforms that allow
                fiction writers and video producers to get paid. And all the
                hard seltzer we can drink. Read on to see how these and dozens
                more inspiring accomplishments are driving this year’s list of
                the World’s Most Innovative Companies. Plus, the 44 Top 10 most
                innovative firms, by sector and region. We hope you’re as
                inspired learning from these businesses as we were in{' '}
                <a href="https://www.fastcompany.com/90474625/how-fast-company-picked-the-worldand8217s-most-innovative-companies-of-2020">
                  selecting them
                </a>.
              </p>
              <div className="mic-2020__header-buttons">
                <button
                  onClick={() => this.scrollToSection(this.top50)}
                  className="mic-2020__button"
                >
                  <span>TOP 50</span>
                </button>
                <button
                  onClick={() => this.scrollToSection(this.sectors)}
                  className="mic-2020__button"
                >
                  <span>Sectors</span>
                </button>
              </div>
            </div>
          </div>
        </header>
        {this.isDesktop && (
          <Top50Shuffle
            isDesktop={this.isDesktop}
            companies={companies}
            config={config}
          />
        )}
        <div className="mic-2020-ad-unit">
          <Ad
            {...combinedAdModel}
            name="flexiblebillboard_1"
            noLazyLoad={true}
          />
          <Ad {...combinedAdModel} name="mobilerectangle_1" noLazyLoad={true} />
        </div>
        <Top50
          forwardRef={this.top50}
          sectorsRef={this.sectors}
          scrollToSection={this.scrollToSection}
          companies={companies}
          config={config}
        />
        <div className="mic-2020-ad-unit">
          <Ad
            {...combinedAdModel}
            name="flexiblebillboard_2"
            noLazyLoad={true}
          />
          <Ad {...combinedAdModel} name="mobilerectangle_2" noLazyLoad={true} />
        </div>
        <SectorsList
          forwardRef={this.sectors}
          title="Sectors"
          sectors={sectors}
          config={config}
          lookupField="sector"
        />
        <SectorsList
          title="Regions"
          sectors={regions}
          config={config}
          lookupField="region"
        />
        <MicMobileMenu
          top50Ref={this.top50}
          sectorsRef={this.sectors}
          scrollToSection={this.scrollToSection}
        />
        <div ref={this.parallax} className="parallax" />
        <div
          className={`mic-2020__back-to-top ${
            backToTop ? 'mic-2020__back-to-top--active' : ''
          }`}
          onClick={this.handleBackToTop}
        />
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: get(state, 'config', {}),
    companies: get(state, 'mic2020Companies.companies', []),
    sectors: get(state, 'mic2020Sectors.sectors', []),
    regions: get(state, 'mic2020Regions.regions', []),
    micYearPage: get(state, 'mic2020YearPage', { error: true })
  };
}

MicYear2020.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  config: PropTypes.shape({}),
  companies: PropTypes.arrayOf(PropTypes.shape({})),
  sectors: PropTypes.arrayOf(PropTypes.shape({})),
  regions: PropTypes.arrayOf(PropTypes.shape({})),
  micYearPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  })
};

MicYear2020.defaultProps = {
  config: {},
  companies: [],
  sectors: [],
  regions: [],
  micYearPage: PropTypes.shape({
    isLoading: false,
    error: false,
    errorMessage: 'Error in micYearPage Props'
  })
};

export default withRouter(connect(mapStateToProps)(MicYear2020));
